/** PWA product name — override at build time with VITE_APP_NAME. */
export const APP_NAME =
  (import.meta.env.VITE_APP_NAME as string | undefined)?.trim() || 'Home Drive';

export const APP_TAGLINE =
  (import.meta.env.VITE_APP_TAGLINE as string | undefined)?.trim() ||
  'Browse shared folders on your home PCs over a private peer-to-peer link.';
